var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQsp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 4.373 4.373 1l4.783 4.783a12.182 12.182 0 0 1 6.97-2.177c2.525 0 4.871.764 6.82 2.075L27.627 1 31 4.373 26.313 9.06a12.18 12.18 0 0 1 2.05 6.784c0 2.59-.804 4.992-2.177 6.97L31 27.627 27.627 31l-4.869-4.87a12.18 12.18 0 0 1-6.633 1.952c-2.51 0-4.842-.755-6.784-2.05L4.374 31 1 27.627l4.962-4.962a12.18 12.18 0 0 1-2.075-6.821c0-2.445.717-4.722 1.951-6.633L1 4.374zm17.886 17.916a7.03 7.03 0 1 1 3.553-3.706l-4.62-4.497-3.452 3.64 4.518 4.562z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQsp);
export default __webpack_public_path__ + "static/media/QSP.afd4daffba79aa22f7066219c1762d1e.svg";
export { ForwardRef as ReactComponent };